import { IAuthState, IUser } from '../../reducers/auth/types';
import Evaporate from 'evaporate';

export const UPDATE_AUTH_STATE = "UPDATE_AUTH_STATE";
export const ADD_USER_DATA = "ADD_USER_DATA";
export const SET_AUTH_EVAPORATE_CLIENT = "SET_AUTH_EVAPORATE_CLIENT";

interface IUpdateAuthAction {
  type: typeof UPDATE_AUTH_STATE;
  payload: IAuthState;
}

interface IAddUserData {
  type: typeof ADD_USER_DATA;
  payload: IUser;
}

export interface SetAuthEvaporateClientAction {
  type: typeof SET_AUTH_EVAPORATE_CLIENT,
  payload: { _e_: Evaporate }
}

export type AuthAction = IUpdateAuthAction | IAddUserData | SetAuthEvaporateClientAction

export const ssoErrors = {
  "invalid_request": "Something went wrong with the sign-in request. Please refresh the page and try again.",
  "unauthorized_client": "This app is not authorized to connect with Microsoft. Please contact your administrator.",
  "access_denied": "You cancelled the sign-in or didn’t grant permission. Please sign in again and approve the request.",
  "unsupported_response_type": "The sign-in method requested isn’t supported. Please contact support if this issue continues.",
  "server_error": "We hit a problem on our side. Please wait a moment and try again.",
  "temporarily_unavailable": "Microsoft’s sign-in service is temporarily busy. Please try again in a few minutes.",
  "invalid_resource": "The system couldn’t find the resource you’re trying to access. Please check with your administrator.",
  "login_required": "We couldn’t find an active session. Please sign in again to continue.",
  "interaction_required": "We need your input to continue. Please sign in again or provide the required consent.",
  "other": "Something went wrong with the sign-in. Please try again.",
}
export type SSOErrorKey = keyof typeof ssoErrors;
